const PASHTO_CARDINAL_UNITS = ["", "یو", "دوه", "درې", "څلور", "پنځه", "شپږ", "اووه", "اته", "نه"];
const PASHTO_ORDINALS_TO_NINETEEN = [
  "",
  "لومړی",
  "دویم",
  "درېیم",
  "څلورم",
  "پنځم",
  "شپږم",
  "اووم",
  "اتم",
  "نهم",
  "لسم",
  "یوولسم",
  "دولسم",
  "دیارلسم",
  "څوارلسم",
  "پنځلسم",
  "شپاړلسم",
  "اتلسم",
  "نولسم",
];
const PASHTO_EXACT_TENS = {
  20: "شلم",
  30: "دېرشم",
  40: "څلوېښتم",
  50: "پنځوسم",
  60: "شپېتم",
  70: "اویایم",
  80: "اتیایم",
  90: "نويیم",
};
const PASHTO_COMPOUND_TENS = {
  20: "ویشتم",
  30: "دېرشم",
  40: "څلوېښتم",
  50: "پنځوسم",
  60: "شپېتم",
  70: "اویایم",
  80: "اتیایم",
  90: "نويیم",
};

const DARI_ORDINALS_TO_NINETEEN = [
  "",
  "اول",
  "دوم",
  "سوم",
  "چهارم",
  "پنجم",
  "ششم",
  "هفتم",
  "هشتم",
  "نهم",
  "دهم",
  "یازدهم",
  "دوازدهم",
  "سیزدهم",
  "چهاردهم",
  "پانزدهم",
  "شانزدهم",
  "هفدهم",
  "هجدهم",
  "نوزدهم",
];
const DARI_CARDINAL_TENS = {
  20: "بیست",
  30: "سی",
  40: "چهل",
  50: "پنجاه",
  60: "شصت",
  70: "هفتاد",
  80: "هشتاد",
  90: "نود",
};
const DARI_ORDINAL_TENS = {
  20: "بیستم",
  30: "سی‌ام",
  40: "چهلم",
  50: "پنجاهم",
  60: "شصتم",
  70: "هفتادم",
  80: "هشتادم",
  90: "نودم",
};

export const toEasternArabicDigits = (value) =>
  String(value).replace(/\d/g, (digit) => "۰۱۲۳۴۵۶۷۸۹"[Number(digit)]);

export const toPashtoOrdinal = (value) => {
  const number = Number(value);
  if (!Number.isInteger(number) || number < 1 || number > 99) return "";
  if (number < 20) return PASHTO_ORDINALS_TO_NINETEEN[number];
  const tens = Math.floor(number / 10) * 10;
  const units = number % 10;
  return units
    ? `${PASHTO_CARDINAL_UNITS[units]} ${PASHTO_COMPOUND_TENS[tens]}`
    : PASHTO_EXACT_TENS[tens];
};

export const toDariOrdinal = (value) => {
  const number = Number(value);
  if (!Number.isInteger(number) || number < 1 || number > 99) return "";
  if (number < 20) return DARI_ORDINALS_TO_NINETEEN[number];
  const tens = Math.floor(number / 10) * 10;
  const units = number % 10;
  // "اول" is only used for the standalone first lesson. Compound ordinal
  // numbers use "یکم", for example "بیست و یکم".
  const ordinalUnit = units === 1 ? "یکم" : DARI_ORDINALS_TO_NINETEEN[units];
  return units
    ? `${DARI_CARDINAL_TENS[tens]} و ${ordinalUnit}`
    : DARI_ORDINAL_TENS[tens];
};

export const generateLessonTitles = (lessonNumber, partNumber) => {
  const lesson = Number(lessonNumber);
  const part = Number(partNumber);
  if (String(lessonNumber).trim() === "0" && String(partNumber).trim() === "0") {
    return {
      en: "Course Introduction",
      pr: "معرفی کورس",
      ps: "د کورس پیژندنه",
    };
  }
  if (!Number.isInteger(lesson) || lesson < 1 || lesson > 99) return null;
  const hasPart = Number.isInteger(part) && part >= 1 && part <= 99;
  const localizedPart = hasPart ? toEasternArabicDigits(part) : "";

  return {
    ps: `${toPashtoOrdinal(lesson)} درس${hasPart ? ` - ${localizedPart} برخه` : ""}`,
    pr: `درس ${toDariOrdinal(lesson)}${hasPart ? ` - قسمت ${localizedPart}` : ""}`,
    en: `Lesson ${lesson}${hasPart ? ` - Part ${part}` : ""}`,
  };
};
